export default "__VITE_ASSET__F3lEjwse__"